import { render, staticRenderFns } from "./BillManage.vue?vue&type=template&id=a276a8aa&scoped=true"
import script from "./BillManage.vue?vue&type=script&lang=js"
export * from "./BillManage.vue?vue&type=script&lang=js"
import style0 from "./BillManage.vue?vue&type=style&index=0&id=a276a8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a276a8aa",
  null
  
)

export default component.exports